<template>
  <div
    v-if="isAuthenticated"
    ref="pageHeaderRoot"
    class="container-fluid bb-page-title-bg d-flex"
    :style="pageHeaderInlineStyle"
  >
    <!---------------------------------->
    <!-- character sheet adjustments   -->
    <!----------------------------------->
    <p
      v-if="getCurrentView == 'character_adjustments'"
      class="bb-page-title my-auto px-4"
    >
      Character Sheet adjustments
    </p>
    <!--------------------------------------------->
    <!-- character sheet adjustments (applied)   -->
    <!--------------------------------------------->
    <p
      v-if="getCurrentView == 'character_adjustments_applied'"
      class="bb-page-title my-auto px-4"
    >
      Character Sheet Adjustments (Applied)
    </p>
    <!--------------------------------------------->
    <!-- character sheet adjustments (optional)   -->
    <!--------------------------------------------->
    <p
      v-if="getCurrentView == 'character_adjustments_optional'"
      class="bb-page-title my-auto px-4"
    >
      Character Sheet Adjustments (Optional)
    </p>
    <!----------------------------->
    <!-- character sheet view    -->
    <!----------------------------->
    <p
      v-if="getCurrentView == 'character_sheets'"
      class="bb-page-title my-auto px-4"
    >
      Character Sheet
    </p>
    <!------------------------------------>
    <!-- all non-character sheet views  -->
    <!------------------------------------>
    <p
      v-if="
        getCurrentView != 'character_sheets' &&
        getCurrentView != 'character_adjustments_applied' &&
        getCurrentView != 'character_adjustments_optional' &&
        getCurrentView != 'character_adjustments'
      "
      class="bb-page-title my-auto px-4"
    >
      {{ getPageTitle }}
    </p>
    <!----------------------------------->
    <!-- add campaign suffix to title  -->
    <!----------------------------------->
    <p
      v-if="showCampaignNameSuffix"
      class="bb-page-arena-name my-auto px-3"
    >
      {{ campaignName }}
    </p>
    <!------------------------------------>
    <!-- add character suffix to title  -->
    <!------------------------------------>
    <p
      v-if="
        getCurrentView == 'character_sheets' ||
        getCurrentView == 'character_adjustments_applied' ||
        getCurrentView == 'character_adjustments_optional'
      "
      class="bb-page-arena-name my-auto px-3 capitalize"
    >
      {{ char_name }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PageHeader',
  data() {
    return {
      stickyNavOffset: 0,
      stickyHeaderHeight: 0,
      stickyResizeObserver: null,
    }
  },
  //---------
  // methods
  //---------
  computed: {
    ...mapGetters('auth', {
      getPageTitle: 'getPageTitle',
      isAuthenticated: 'isAuthenticated',
      getCurrentView: 'getCurrentView',
    }),
    ...mapGetters('combat', {
      campaignName: 'getCampaignName',
    }),
    ...mapGetters('characters', {
      getCurrentCharacter: 'getCurrentCharacter',
    }),
    char_name() {
      return this.getCurrentCharacter ? this.getCurrentCharacter.name : ''
    },
    showCampaignNameSuffix() {
      return (
        this.getCurrentView == 'dm_combat' ||
        this.getCurrentView == 'player_combat' ||
        (this.getCurrentView == 'characters' &&
          this.$route?.name == 'combatCharacters') ||
        this.getCurrentView == 'campaign_artefacts'
      )
    },
    pageHeaderInlineStyle() {
      return {
        position: 'sticky',
        top: `${this.stickyNavOffset}px`,
        zIndex: 2500,
      }
    },
  },
  mounted() {
    this.updateStickyMetrics()
    window.addEventListener('resize', this.updateStickyMetrics)

    if (typeof ResizeObserver !== 'undefined') {
      this.stickyResizeObserver = new ResizeObserver(() => {
        this.updateStickyMetrics()
      })

      const navElement = this.getNavElement()
      if (navElement) {
        this.stickyResizeObserver.observe(navElement)
      }

      if (this.$refs.pageHeaderRoot) {
        this.stickyResizeObserver.observe(this.$refs.pageHeaderRoot)
      }
    }
  },
  updated() {
    this.updateStickyMetrics()
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateStickyMetrics)
    if (this.stickyResizeObserver) {
      this.stickyResizeObserver.disconnect()
      this.stickyResizeObserver = null
    }
  },
  methods: {
    getNavElement() {
      const previousElement = this.$refs.pageHeaderRoot?.previousElementSibling
      if (previousElement?.classList?.contains('bb-navbar')) {
        return previousElement
      }

      return (
        document.getElementById('nav') || document.querySelector('.bb-navbar')
      )
    },
    updateStickyMetrics() {
      this.$nextTick(() => {
        const navElement = this.getNavElement()
        const headerElement = this.$refs.pageHeaderRoot
        const navHeight = navElement
          ? navElement.getBoundingClientRect().height
          : 0
        const headerHeight = headerElement
          ? headerElement.getBoundingClientRect().height
          : 0

        this.stickyNavOffset = navHeight
        this.stickyHeaderHeight = headerHeight

        const root = document.documentElement
        root.style.setProperty('--bb-sticky-nav-height', `${navHeight}px`)
        root.style.setProperty('--bb-page-header-height', `${headerHeight}px`)
        root.style.setProperty(
          '--bb-sticky-table-top',
          `${navHeight + headerHeight}px`,
        )
      })
    },
  },
}
</script>
